<!--
  银行卡
  lovi 2020-1-11
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        bankId ? $t('bankCard.editBankCard') : $t('bankCard.bindingBankCard')
      "
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    >
      <span slot="right" v-if="bankId" @click="unbindFlag = true">
        {{ $t("common.removeBinding") }}
      </span>
    </van-nav-bar>

    <div class="scroll-wrapper">
      <van-cell
        :title="$t('bankCard.belonging')"
        required
        is-link
        :value="countryName ? countryName : $t('bankCard.selectBelonging')"
        @click="countryFlag = true"
      />
      <van-field
        v-model="bank.name"
        :label="
          bank.country == 3
            ? $t('bankCard.accountName')
            : $t('bankCard.cardHolder')
        "
        :placeholder="
          bank.country == 3
            ? $t('bankCard.enterAccountName')
            : $t('bankCard.enterCardHolder')
        "
        required
        clearable
      />
      <van-field
        v-model="bank.cardNumber"
        type="number"
        :label="
          bank.country == 3
            ? $t('bankCard.bankAccount')
            : $t('bankCard.bankCardNumber')
        "
        :placeholder="
          bank.country == 3
            ? $t('bankCard.enterBankAccount')
            : $t('bankCard.enterBankNumber')
        "
        required
        clearable
      />
      <van-field
        v-model="bank.bankName"
        :label="$t('bankCard.openingBank')"
        :placeholder="$t('bankCard.enterAccountBank')"
        required
        clearable
      />
      <van-field
        v-if="bank.country == 3"
        v-model="bank.bankBranch"
        :label="$t('bankCard.branch')"
        :placeholder="$t('bankCard.enterBranchAddress')"
        required
        clearable
      />
      <van-field
        v-model="bank.phone"
        :label="$t('common.mobileNumber')"
        :placeholder="$t('common.enterMobile')"
        type="digit"
        maxlength="11"
        clearable
      />

      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          :loading="btnLoading"
          @click="submit"
        >
          {{ bankId ? $t("common.save") : $t("bankCard.confirmBinding") }}
        </van-button>
        <p class="tips">{{ $t("bankCard.bankTips") }}</p>
      </div>
    </div>

    <!-- 选择归属地 -->
    <van-popup v-model="countryFlag" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :title="$t('bankCard.selectBelonging')"
        :default-index="countryIndex"
        :columns="countryList"
        @cancel="countryFlag = false"
        @confirm="countryConfirm"
      />
    </van-popup>

    <!-- 解除绑定 -->
    <van-dialog
      v-model="unbindFlag"
      show-cancel-button
      @confirm="unbindBankCard"
      confirm-button-color="#FE7800"
    >
      <p class="dialog-content">{{ $t("common.sureRemoveBinding") }}</p>
    </van-dialog>

    <transition name="slide">
      <status
        v-if="statusFlag"
        :statusFlag.sync="statusFlag"
        :bankId="bankId"
      />
    </transition>
  </div>
</template>

<script>
import Status from "./status";
export default {
  name: "bindCard",
  props: {
    parentPage: {
      type: String, //父页面
      default: function() {
        return "";
      }
    }
  },
  components: {
    Status
  },
  data() {
    return {
      bankList: [], // 银行卡列表
      bank: {
        country: "",
        name: "",
        cardNumber: "",
        bankName: "",
        bankBranch: "",
        phone: ""
      },

      // 归属地
      countryFlag: false,
      countryName: "",
      countryIndex: 0,
      countryList: [
        { text: this.$t("bankCard.philippines"), country: 2 },
      ],

      bankId: 0, // 银行卡ID
      btnLoading: false, //按钮load
      unbindFlag: false, //解除绑定Flag

      statusFlag: false //状态Flag
    };
  },
  created() {
    this.bankId = this.$route.query.bankId;
    if (this.bankId) {
      this._getBankCardById();
    }
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 顶部返回
      let vm = this;
      if (vm.parentPage == "withdraw") {
        vm.$emit("update:bindCardFlag", false);
      } else {
        vm._back();
      }
    },
    countryConfirm(picker, value) {
      // 选择归属地
      let vm = this;
      vm.countryFlag = false;
      vm.countryIndex = value;
      vm.countryName = picker.text;
      vm.bank.country = picker.country;
      console.log("countryConfirm", picker);
    },
    _getBankCardById() {
      // 获取银行卡信息
      let vm = this;
      vm.$post(
        "/app/bankcard/getBankCardById",
        { id: vm.bankId },
        { loading: true }
      ).then(res => {
        console.log("getBankCardById", res);
        vm.bank.country = res.country;
        vm.countryName =
          vm.bank.country == 1
            ? vm.countryList[0].text
            : vm.bank.country == 2
            ? vm.countryList[1].text
            : vm.countryList[2].text;
        vm.countryIndex =
          vm.bank.country == 1 ? 0 : vm.bank.country == 2 ? 1 : 2;
        vm.bank.name = res.name;
        vm.bank.cardNumber = res.card_number;
        vm.bank.bankName = res.bank_name;
        vm.bank.bankBranch = res.bank_branch;
        vm.bank.phone = res.phone;
        console.log("getBankCardById", vm.bank);
      });
    },
    submit() {
      // 确认提交
      let vm = this;
      if (vm.bank.country == "") {
        vm.$toast(vm.$t("bankCard.selectBelonging"));
        return;
      }
      if (vm.bank.name == "") {
        let tips = vm.$t("bankCard.enterCardHolder");
        if (vm.bank.country == 3) {
          tips = vm.$t("bankCard.enterAccountName");
        }
        vm.$toast(tips);
        return;
      }
      if (vm.bank.cardNumber == "") {
        let tips = vm.$t("bankCard.enterBankNumber");
        if (vm.bank.country == 3) {
          tips = vm.$t("bankCard.enterBankAccount");
        }
        vm.$toast(tips);
        return;
      }
      if (vm.bank.bankName == "") {
        vm.$toast(vm.$t("bankCard.enterAccountBank"));
        return;
      }
      if (vm.bank.country == 3 && vm.bank.bankBranch == "") {
        vm.$toast(vm.$t("bankCard.enterBranchAddress"));
        return;
      }

      // 参数
      let params = {};
      params.country = vm.bank.country;
      params.name = vm.bank.name;
      params.card_number = vm.bank.cardNumber;
      params.bank_name = vm.bank.bankName;
      params.bank_branch = vm.bank.bankBranch;
      params.phone = vm.bank.phone;
      vm.btnLoading = true;
      if (vm.bankId) {
        vm.editBankCard(params);
      } else {
        vm.addbankCard(params);
      }
    },
    addbankCard(params) {
      // 添加银行卡
      let vm = this;
      vm.$post("/app/bankcard/addbankcard", params, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log("addbankCard", res);
          if (res.code == 0) {
            vm.$store.dispatch("GET_USER_INFO");
            if (vm.parentPage == "withdraw") {
              vm.$store.dispatch("GET_USER_INFO");
              vm.$emit("update:bindCardFlag", false);
              vm.$emit("getWithdrawalToBank");
            } else {
              vm.statusFlag = true;
            }
          } else {
            vm.$toast(res.msg);
          }
        }
      );
    },
    editBankCard(params) {
      // 编辑银行卡
      let vm = this;
      params.id = vm.bankId;
      vm.$post("/app/bankcard/editbankcard", params, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log("editBankCard", res);
          if (res.code == 0) {
            vm.statusFlag = true;
          } else {
            vm.$toast(res.msg);
          }
        }
      );
    },
    unbindBankCard() {
      // 解除绑定
      let vm = this;
      vm.$post(
        "/app/bankcard/unbindBankCard",
        { id: vm.bankId },
        { alert: true }
      ).then(res => {
        console.log("unbindBankCard", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm._back();
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  .van-field__label {
    flex: 1;
    margin-right: 10px;
  }
  .van-cell__value {
    flex: initial;
  }
  .van-field__control {
    text-align: right;
  }
}
</style>
